<div class="visita-container">

  <!-- Cabeçalho -->
  <div class="visita-header">
    <div>
      <span class="chart-eyebrow">Marmoraria</span>
      <h2 class="chart-title">Baixa de Visitas</h2>
      <p class="chart-subtitle">Registre o início e o encerramento das visitas agendadas com sua localização.</p>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button"
            (click)="carregarAgenda()" [disabled]="isLoading || idFuncionario == null">
      Atualizar
    </button>
  </div>

  <!-- Barra de filtros -->
  <div class="visita-toolbar">
    <div class="data-filtro">
      <label for="dataVisita" class="form-label">Data</label>
      <input id="dataVisita" type="date" class="form-control" [(ngModel)]="dataSelecionada"
             (change)="onDataChange()" [disabled]="idFuncionario == null" />
    </div>
  </div>

  <!-- Estado: carregando -->
  <div *ngIf="isLoading" class="state-box">
    <div class="spinner-border text-primary" role="status"></div>
    <span>Carregando agenda...</span>
  </div>

  <!-- Estado: erro -->
  <div *ngIf="hasError && !isLoading" class="state-box error">
    <span *ngIf="idFuncionario == null">Seu usuário não está vinculado a um funcionário.</span>
    <span *ngIf="idFuncionario != null">Não foi possível carregar a agenda.</span>
    <button *ngIf="idFuncionario != null" class="btn btn-primary btn-sm" type="button" (click)="carregarAgenda()">
      Tentar novamente
    </button>
  </div>

  <!-- Estado: vazio -->
  <div *ngIf="!isLoading && !hasError && visitas.length === 0" class="state-box">
    <span>Nenhum agendamento para esta data.</span>
  </div>

  <!-- Lista de agendamentos -->
  <div *ngIf="!isLoading && !hasError && visitas.length > 0" class="visita-lista">
    <div class="visita-card" *ngFor="let visita of visitas; trackBy: trackByVisita">

      <div class="card-topo">
        <div class="card-hora">{{ horaDe(visita.agendamento.dataAgendamento) || '--:--' }}</div>
        <span class="status-badge" [ngClass]="statusClasse(visita.status)">
          {{ statusLabel(visita.status) }}
        </span>
      </div>

      <div class="card-corpo">
        <h3 class="card-cliente">{{ nomeCliente(visita) }}</h3>
        <p class="card-linha" *ngIf="visita.agendamento.tipoAgendamento">
          <strong>Tipo:</strong> {{ visita.agendamento.tipoAgendamento }}
        </p>
        <p class="card-linha" *ngIf="visita.agendamento.enderecoAgendamento">
          <strong>Endereço:</strong> {{ visita.agendamento.enderecoAgendamento }}
        </p>
        <p class="card-linha" *ngIf="visita.agendamento.telefoneContato">
          <strong>Contato:</strong>
          <a [href]="'tel:' + visita.agendamento.telefoneContato">{{ visita.agendamento.telefoneContato }}</a>
        </p>
        <p class="card-linha" *ngIf="visita.agendamento.descricao">
          <strong>Descrição:</strong> {{ visita.agendamento.descricao }}
        </p>
      </div>

      <!-- Histórico de registros -->
      <div class="card-registros" *ngIf="visita.registros.length > 0">
        <div class="registro-item" *ngFor="let r of visita.registros">
          <span class="registro-tipo" [ngClass]="r.tipoRegistro === 'E' ? 'tipo-entrada' : 'tipo-saida'">
            {{ tipoRegistroLabel(r.tipoRegistro) }}
          </span>
          <span class="registro-hora">{{ horaDe(r.timestampCheckin) }}</span>
        </div>
      </div>

      <!-- Observação + ações -->
      <div class="card-acoes" *ngIf="visita.status !== 'CONCLUIDA'">
        <input type="text" class="form-control form-control-sm mb-2"
               placeholder="Observação (opcional)"
               [(ngModel)]="visita.descricao" [disabled]="visita.processando" />

        <div class="botoes">
          <button class="btn btn-success flex-fill" type="button"
                  (click)="iniciarVisita(visita)" [disabled]="!podeIniciar(visita)">
            <span *ngIf="visita.processando" class="spinner-border spinner-border-sm me-1" role="status"></span>
            Iniciar visita
          </button>
          <button class="btn btn-primary flex-fill" type="button"
                  (click)="encerrarVisita(visita)" [disabled]="!podeEncerrar(visita)">
            <span *ngIf="visita.processando" class="spinner-border spinner-border-sm me-1" role="status"></span>
            Encerrar visita
          </button>
        </div>
      </div>

      <div class="card-concluida" *ngIf="visita.status === 'CONCLUIDA'">
        ✓ Visita concluída
      </div>

    </div>
  </div>

</div>
